import { useSession } from '@/Session';

const Friendship = ({ friendship: { friend }, selected, onClick }) => {
  const {
    session: { userId },
  } = useSession();
  return (
    <button
      className={`btn p-1 ${selected ? 'btn-primary' : ''}`}
      onClick={onClick}
    >
      {friend.id === userId ? 'Moi-même' : friend.name}
    </button>
  );
};

export default Friendship;
